import React from "react";
import { AboutUsInfo, Seo, WhyChooseUsList } from "../components";
import { PAGE_SEO } from "../common";

export const AboutPage = () => {
  return (
    <>
      <Seo {...PAGE_SEO.about} />
      <div className="about-page-container-margin">
        <AboutUsInfo />
        <WhyChooseUsList />
      </div>
    </>
  );
};
